$.validator.addMethod("emaillength", function (value, element, params) {
    value = value.trim();
    if (this.optional(element)) return true;
    const local = value.split('@')[0];
    return value.length <= parseInt(params.maxlength) && local.length <= parseInt(params.localmax);
});
$.validator.unobtrusive.adapters.add("emaillength", ["maxlength", "localmax"], function (options) {
    options.rules["emaillength"] = options.params;
    options.messages["emaillength"] = options.message;
});

$.validator.addMethod("emailformat", function (value, element, params) {
    value = value.trim();
    if (this.optional(element)) return true;
    return new RegExp(params.pattern).test(value);
});
$.validator.unobtrusive.adapters.add("emailformat", ["pattern"], function (options) {
    options.rules["emailformat"] = options.params;
    options.messages["emailformat"] = options.message;
});
